/* eslint-disable */

import mainComponent from '../../mainComponent'
import api from '../../../resources/apiProvider'
import DatePicker from 'vue2-datepicker'
import cleanObject from 'clean-deep'
import _ from 'lodash'
import moment from 'moment'
import queryString from 'query-string'
import helperGlobal from '../../../services/helperService'
import Multiselect from 'vue-multiselect'
import uniqId from 'uniqid'
import toastr from 'toastr/build/toastr.min'
import appConfig from '../../../config/app'
import Treeselect, { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import tableHelper from "../../../resources/tableHelper"

import yadcf from 'yadcf'
import chartComponent from './chart.vue'

import fakeData from '../../../resources/mock/dm_operational_cost'
import router from '../../../router';

const columnFilterDef = [
    {
        column_number: 0,
        column_data_type: "html",
        html_data_type: "text",
        filter_default_label: "Select indicator",
    }
]

export default {
    components: {mainComponent, DatePicker, Multiselect, Treeselect, chartComponent},
    data() {
        return {
            saveJson: '',
            timePickerOptions: {
                lang: 'fr',
            },
            initialData: [],
            data: [],
            listIndicators: [],
            filters: {
                network: '',
                category: '',
                startDate: '',
                endDate: ''
            },
            hasData: false,
            counterGraph: 0,
            freqTimeSelected: '',
            loaders: {
                missions: false
            },
            rights: {
                saveTemplateFm: true
            },
            multiselect: {
                labels: {
                    presstoSelect: 'Sélectionner',
                    selectedLabel: 'Sélectionné',
                    deselectLabel: 'Déselectionner'
                }
            },
            multiple: true,
            clearable: true,
            searchable: true,
            openOnClick: true
        }
    },
    beforeRouteUpdate (to, from, next) {
        if(to.params.network) {
            this.filters.network = to.params.network
        }

        if(to.params.category) {
            this.filters.category = to.params.category
        }

        this.rights.saveTemplateFm = this.userIsAdmin
        this.freqTimeSelected = 'month'

        let tableContainer = $('#js-dom-table-container')
        tableContainer.empty()

        this.counterGraph = 0

        this.getData(this.getAllFilters, (data) => {
            this.initialData = data
            let arr = tableHelper.getDataBetween2Dates(this.initialData, this.filters.startDate, this.filters.endDate)
            this.data = arr
            this.hasData = true
            this.listIndicators = tableHelper.getIndicatorsList(this.data)
            this.renderTable(this.freqTimeSelected)
        })

        next()
    },
    created() {
        let allParams = _.clone(this.$route.params)
        this.filters = allParams

        this.rights.saveTemplateFm = this.userIsAdmin
        this.freqTimeSelected = 'month'
    },
    mounted() {
        this.loadHighLevelFilters()

        this.$nextTick(function () {
            this.getData(this.getAllFilters, (data) => {
                this.initialData = data
                let arr = tableHelper.getDataBetween2Dates(this.initialData, this.filters.startDate, this.filters.endDate)
                this.data = arr
                this.hasData = true
                this.listIndicators = tableHelper.getIndicatorsList(this.data)
                this.renderTable(this.freqTimeSelected)
            })
        })
    },
    watch: {

    },
    methods: {
        /**
         * Récupération des données depuis l'API
         *
         * @param params
         * @param callback
         * @returns {Promise<void>}
         */
        async getData(params = {}, callback) {
            let res = api.getFromUri(api.getResourceUri().tod.all)
            let result = await res.save(params, {})

            callback(result.data)
        },
        normalizer(node) {
            const normalizedNode = {
                _id: node._id,
                desc: node.desc,
                id: node._id,
                label: node._id + ' - ' + node.desc
            }

            if(node.children && node.children.length > 0) {
                normalizedNode.children = node.children.map(this.normalizer)
            }

            return normalizedNode
        },
        /**
         * Récupérer les paramètres network et category de l'url
         */
        loadHighLevelFilters() {
            let vm = this
            let allParams = _.clone(vm.$route.params)
            // gestion des filtres haut niveau
            if (!_.isUndefined(allParams.filters)) {
                let passFilters = queryString.parse(allParams.filters)
                vm.filters = passFilters
            }
        },
        /**
         * Transformation des données brutes et initialisation du tableau DataTable
         */
        renderTable(typeSelected = 'month') {
            let tableContainer = $('#js-dom-table-container')
            let dtTableJq = tableHelper.createTableDomElement(tableContainer)

            let dataByDateCol = this.getDataByDateCol(typeSelected, this.data)

            let columnDef = tableHelper.getColumnMonthNameDt(dataByDateCol.columnsDtFormated)

            let dt2 = dtTableJq.DataTable({
                dom: 'lBfrtip',
                data: dataByDateCol.finalArray,
                "columns": dataByDateCol.columnsDtFormated,
                "columnDefs": columnDef,
                "lengthMenu": [[10, 50, -1], [10, 50, "All"]],
                buttons: [
                    {
                        extend: 'excelHtml5',
                        text: 'Excel',
                        title: this.getExportName(),
                        exportOptions: {
                            orthogonal: 'exportExcel'
                        }
                    },
                    {
                        extend: 'csvHtml5',
                        text: 'CSV',
                        title: this.getExportName(),
                        exportOptions: {
                            orthogonal: 'exportCsv'
                        }
                    }
                ]
            })
            //yadcf.init(dt2, columnFilterDef)
        },
        /**
         * On effectue les transformations et aggrégations sur les raw data
         * Retourne les data au format datatables ainsi que la liste des colonnes
         */
        getDataByDateCol(typeSelected, data) {
            let groupedData = typeSelected === 'month' ? tableHelper.groupByMonth(data) : tableHelper.groupByWeek(data)
            let groupedDataAvg = tableHelper.averageByIndicator(groupedData)
            let dataByDateCol = tableHelper.getByColumnData(groupedDataAvg.list, typeSelected)
            return dataByDateCol
        },
        changeFreqTimeSelected: function(event) {
            let vm = this
            let valSelect = event.target.value
            vm.freqTimeSelected = valSelect

            let tableContainer = $('#js-dom-table-container')
            tableContainer.empty()

            vm.renderTable(valSelect)
        },
        selectDate() {
            let arr = tableHelper.getDataBetween2Dates(this.initialData, this.filters.startDate, this.filters.endDate)
            this.data = arr;
            this.listIndicators = tableHelper.getIndicatorsList(this.data)
            let tableContainer = $('#js-dom-table-container')
            tableContainer.empty()
            this.renderTable(this.freqTimeSelected)
        },
        clickAddGraph: function(event) {
            this.counterGraph += 1
        },
        clickCloseGraph: function(event) {
            let currentTarget = event.currentTarget
            currentTarget = $(currentTarget)
            let parentDiv = currentTarget.parent('div')
            parentDiv.remove()
        },
        getExportName() {
            let allData = this.data
            let bornedDates = tableHelper.getBornedDateOfArray(allData)
            let minDateSelected = !tableHelper.isVeryNull(this.filters.startDate)
                ? this.filters.startDate : bornedDates.minDate
            let maxDateSelected = !tableHelper.isVeryNull(this.filters.endDate)
                ? this.filters.endDate : bornedDates.maxDate
            let categoryName = this.filters.category
            return categoryName +
                '-' +
                moment(minDateSelected).format('DD_MM_YYYY') +
                '-' +
                moment(maxDateSelected).format('DD_MM_YYYY')
        }
    },
    computed: {
        getCategoryName() {
            let allParams = _.clone(this.$route.params)
            return allParams.category
        },
        getNetworkName() {
            let allParams = _.clone(this.$route.params)
            return allParams.network
        },
        /**
         * retourne les filtres de haut niveau,
         * @returns {*}
         */
        getAllFilters() {
            let filters = _.clone(cleanObject(this.filters))
            return _.clone(filters)
        },
        getCounterGraph() {
            let counter = this.counterGraph,
                arr = [];
            for (let i = 0; i < counter; i++) {
                arr.push(i + 1);
            }
            return arr
        },
        /**
         * renvoit les conditions de desactivation du
         * bouton de la recherche
         * @returns {boolean}
         */
        btnSearchDisable() {
            let conditions = this.loaders.missions || _.isEmpty(this.getAllFilters);
            return conditions
        },
        userIsAdmin() {
            return this.$store.storeAuth.getters.isAdmin
        },
        getAllUser() {
            return this.$store.storeAuth.getters.getUser
        },
        startDate() {
            return this.filters.startDate
        },
        endDate() {
            return this.filters.endDate
        }
    },
    destroyed() {
    }
}